import React, { useContext, createContext } from "react";
import { useBrandContextQuery } from "Shared/util/web-api-hooks";
import { BrandContextResource } from "Shared/util/types";

type BrandContextModel = {
    brandData: BrandContextResource;
    loadingBrandData: boolean;
};

const defaultBrandData: BrandContextResource = {
    acconomyIntegration: false,
    businessLoansUrl: "",
    contactEmailAddress: "",
    customerServiceEmailAddress: "",
    deActivatedExportOptions: [],
    deActiveMenus: [],
    defaultExportOption: "",
    erpIntegration: false,
    fortnoxIntegration: false,
    imbox: {
        paymentInformationArticleId: "",
        widgetId: "",
    },
    invoiceEmailAddress: "",
    legalName: "",
    name: "",
    organizationNumber: "",
    phone: "",
    showOCRNumber: false,
    supportEmailAddress: "",
    supportedLanguages: [],
};

const BrandContext = createContext<BrandContextModel>({
    brandData: defaultBrandData,
    loadingBrandData: true,
});

const useBrandContext = () => {
    const context = useContext(BrandContext);
    if (context === undefined)
        throw new Error("useBrandContext must be used within a BrandProvider");
    return context;
};

export const BrandProvider: React.FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    const [data, loading] = useBrandContextQuery();

    const contextValues = {
        brandData: data || defaultBrandData,
        loadingBrandData: loading,
    };

    if (loading) {
        return null;
    }

    return (
        <BrandContext.Provider value={contextValues}>
            {children}
        </BrandContext.Provider>
    );
};

export default useBrandContext;
